var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackAltRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6036 5.29289C15.9941 5.68342 15.9941 6.31658 15.6036 6.70711L10.3107 12L15.6036 17.2929C15.9941 17.6834 15.9941 18.3166 15.6036 18.7071C15.213 19.0976 14.5799 19.0976 14.1893 18.7071L8.36612 12.8839C7.87796 12.3957 7.87796 11.6043 8.36612 11.1161L14.1893 5.29289C14.5799 4.90237 15.213 4.90237 15.6036 5.29289Z",
    fill: "#101820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackAltRounded);
export default __webpack_public_path__ + "static/media/arrow-back-alt-rounded.0fcf82acdb3a56cac166f5b23158bb76.svg";
export { ForwardRef as ReactComponent };